import React from 'react';
import { IconProps } from '.';

const SvgZExpressFillRounded = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M23 12.002c0-4.525-3.834-7.577-8.562-7.5-.876.013-1.549.122-2.5.392-2.98.85-8.846 4.479-10.84 5.989-.2.152-.07.461.187.436l12.002-1.178c.184-.018.287-.207.2-.362l-1.155-2.025c-.128-.224.14-.461.364-.325l6.981 4.262a.36.36 0 0 1 0 .62l-6.98 4.262c-.225.137-.493-.101-.365-.325l1.156-2.025c.089-.155-.017-.344-.2-.362L1.284 12.683c-.256-.025-.389.284-.186.437 1.993 1.51 7.86 5.136 10.84 5.986.95.27 1.623.379 2.5.392C19.165 19.578 23 16.526 23 12v.002Z'
      />
    </svg>
  );
};

export default SvgZExpressFillRounded;
